import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';

// Async thunk to fetch tickets with provided params
export const fetchTickets = createAsyncThunk('tickets/fetchTickets', async ({ params = {}, listKey = 'all' } = {}) => {
  const response = await api.get('/tickets', { params });
  // normalize: support { items, total } or raw array
  const data = response.data;
  return {
    listKey,
    items: data.items || data,
    total: data.total || (Array.isArray(data) ? data.length : 0),
    fetchedAt: Date.now(),
  };
});

let pollerMap = {};
export const startTicketsPolling = ({ intervalMs = 30000, params = {}, listKey = 'all' } = {}) => (dispatch) => {
  // initial fetch
  dispatch(fetchTickets({ params, listKey }));
  if (pollerMap[listKey]) clearInterval(pollerMap[listKey]);
  pollerMap[listKey] = setInterval(() => dispatch(fetchTickets({ params, listKey })), intervalMs);
};

export const stopTicketsPolling = (listKey = null) => () => {
  if (listKey) {
    if (pollerMap[listKey]) {
      clearInterval(pollerMap[listKey]);
      delete pollerMap[listKey];
    }
  } else {
    // stop all
    Object.keys(pollerMap).forEach(k => { clearInterval(pollerMap[k]); delete pollerMap[k]; });
  }
};

const slice = createSlice({
  name: 'tickets',
  initialState: {
    // lists keyed by listKey (e.g., 'all', 'mine:123')
    lists: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickets.pending, (state, action) => {
        const listKey = action.meta.arg && action.meta.arg.listKey ? action.meta.arg.listKey : 'all';
        if (!state.lists[listKey]) state.lists[listKey] = { items: [], total: 0, loading: false, error: null, lastUpdated: null };
        state.lists[listKey].loading = true;
        state.lists[listKey].error = null;
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        const { listKey, items, total, fetchedAt } = action.payload;
        state.lists[listKey] = state.lists[listKey] || { items: [], total: 0, loading: false, error: null, lastUpdated: null };
        state.lists[listKey].loading = false;
        state.lists[listKey].items = items;
        state.lists[listKey].total = total;
        state.lists[listKey].lastUpdated = fetchedAt;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        const listKey = action.meta.arg && action.meta.arg.listKey ? action.meta.arg.listKey : 'all';
        state.lists[listKey] = state.lists[listKey] || { items: [], total: 0, loading: false, error: null, lastUpdated: null };
        state.lists[listKey].loading = false;
        state.lists[listKey].error = action.error.message;
      });
  },
});

export default slice.reducer;
